document.addEventListener('globo.formbuilder.form.submitted', function(e) {
  const { formId } = e.detail;
  const form = e.detail.form;
  const email_ = form.querySelector('input[data-type="email"]')?.value
    || form.querySelector('input[name="email"]')?.value;
  // Phone - scoped to this form's own .iti wrapper  
  const phoneInput = form.querySelector('input[data-type="phone"]');  
  const itiWrapper = phoneInput?.closest('.iti');  
  const dialCode =  
  itiWrapper?.querySelector('.iti__selected-dial-code')?.innerText?.trim();  
  const phoneRaw = phoneInput?.value?.trim();  
  const phone_ = (dialCode && phoneRaw) ? dialCode + phoneRaw : phoneRaw || null;  
  if (typeof TriplePixel !== 'function') return;

  // Contact Us — Form ID 47245
  if (formId == 47245) {
    const payload = {
      formId: 47245,
      formType: 'contactEnquiry',
      pageUrl: window.location.href,
      email: email_,
      phone: phone_
    }
    TriplePixel('custom', 'contactEnquiry', payload);
  }
// Book Appointment — Form ID 47875
  if (formId == 47875) {
    const payload = {
      formId: 47875,
      formType: 'bookAppointmentEmbedded',
      pageUrl: window.location.href,
      email: email_,
      phone: phone_
    }
    TriplePixel('custom', 'bookAppointmentEmbedded', payload);
  }
  // Bespoke Jewellery & Product Customisation — Form ID 45043 (shared)
  // Differentiated by page URL
  if (formId == 45043) {
    const isBespoke = window.location.pathname.includes('/pages/bespoke-jewellery');  
    const eventName = isBespoke ? 'bespokeEnquiry' : 'productCustomization';  
    const payload = {
      formId: 45043,
      formType: eventName,
      pageUrl: window.location.href,
      email: email_,
      phone: phone_
    };

    if (!isBespoke) {
      try {
        const product = window.ShopifyAnalytics
          && window.ShopifyAnalytics.meta
          && window.ShopifyAnalytics.meta.product;
        if (product && product.id) {
          payload.productId = String(product.id);
        }
      } catch (err) {
        console.log('TriplePixel bespokeEnquiry is not productCustomization:', err);  
      }
    }
    TriplePixel('custom', eventName, payload);
  }
  if (formId == 45550) {
    const payload = {
      formId: 45550,
      formType: 'requestCallback',
      pageUrl: window.location.href,
      email: email_,
      phone: phone_
    };  
    try {
      const product = window.ShopifyAnalytics
        && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product;
      if (product && product.id) {
        payload.productId = String(product.id);
      }
    } catch (err) {
      console.log('TriplePixel requestCallback not on PDP:', err);
    }
    TriplePixel('custom', 'requestCallback', payload);
  }

  if (formId == 45606) {
    const payload = {
      formId: 45606,
      formType: 'bookAppointmentPopup',
      pageUrl: window.location.href,
      email: email_,
      phone: phone_
    };

    try {
      const product = window.ShopifyAnalytics
        && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product;
      if (product && product.id) {
        payload.productId = String(product.id);
      }
    } catch (err) {
      console.log('TriplePixel bookAppointmentPopup not on PDP:', err);
    }
    TriplePixel('custom', 'bookAppointmentPopup', payload);
  }
});
